import { HashRouter, Route } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";

// page & layout imports
import Homepage from "./pages/Homepage";
import TaskPage from "./pages/TaskPage";
import Category from "./pages/Category";
import SiteHeader from "./components/SiteHeader";
import Unauthorized from "./pages/Unauthorized";
import { PageLayout } from "./auth-components/PageLayout";
import BudgetingToolPage from "./pages/BudgetingToolPage";

// create projects list component
const ProjectsContainer = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <Homepage />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Unauthorized />
      </UnauthenticatedTemplate>
    </>
  );
};

// create tasks list component
const TasksContainer = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <TaskPage />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Unauthorized />
      </UnauthenticatedTemplate>
    </>
  );
};

// create categories component
const CategoriesContainer = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <Category />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Unauthorized />
      </UnauthenticatedTemplate>
    </>
  );
};
// create tool component
const ToolContainer = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <BudgetingToolPage />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Unauthorized />
      </UnauthenticatedTemplate>
    </>
  );
};
function App() {
  return (
    <>
      <div className="App">
        <PageLayout>
          <HashRouter>
            <Route path="/" component={ProjectsContainer} exact />
            <Route path="/task/:id" component={TasksContainer} />
            <Route path="/category/:id" component={CategoriesContainer} />
            <Route path="/budgeting/:id/:category" component={ToolContainer} />
          </HashRouter>
        </PageLayout>
      </div>
    </>
  );
}

export default App;
